import styled from 'styled-components';

export const StyledGranularity = styled.p`
  font-size: 14px;
  color: #6d6c6c;
  font-weight: 900;
  margin-bottom: 0;
`;
